import React from 'react';
import { Card, Row, Col, Empty, Spin, DatePicker } from 'antd';
import { CardTitleText } from '../../../../../../shared/globalStyling/styledText';
import { isEmpty } from 'lodash';
import moment from 'moment';
import SingleAxisArea from '../../signups/components/SingleAxisArea';

const styles = {
  container: {
    backgroundColor: '#fff',
    borderTop: 'solid 1px #e8e8e8',
    marginBottom: '1%',
  },
};

const SignUpsV2Chart = ({ data, loading, dateRange, onDateRangeChange, campaignOrder }) => {
  // Calculate initial date range from data if not provided
  const getInitialDateRange = () => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      return dateRange;
    }

    // If data exists, use the first and last dates from data
    if (data && data.length > 0) {
      const dates = data.map(item => item.date).sort();
      return [
        moment(dates[0], 'YYYY-MM-DD'),
        moment(dates[dates.length - 1], 'YYYY-MM-DD')
      ];
    }

    // Fall back to campaign dates
    if (campaignOrder?.startDate && campaignOrder?.endDate) {
      return [
        moment(campaignOrder.startDate),
        moment(campaignOrder.endDate)
      ];
    }

    return [null, null];
  };

  const initialDateRange = getInitialDateRange();
  if (loading) {
    return (
      <Row style={styles.container} type="flex">
        <Col xs={24}>
          <Card
            title={<CardTitleText text={'Sign-Up Chart by Date'} />}
            style={{ height: '35em' }}
            headStyle={{ borderWidth: '2px' }}
            bodyStyle={{ padding: '2%', paddingBottom: '3%' }}
            bordered
          >
            <Row type="flex" justify="center" align="middle" style={{ height: 300 }}>
              <Spin size="large" />
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }

  const hasData = data && !isEmpty(data);

  if (!hasData) {
    return (
      <Row style={styles.container} type="flex">
        <Col xs={24}>
          <Card
            title={<CardTitleText text={'Sign-Up Chart by Date'} />}
            style={{ height: '35em' }}
            headStyle={{ borderWidth: '2px' }}
            bodyStyle={{ padding: '2%', paddingBottom: '3%' }}
            bordered
          >
            <Row type="flex" justify="center" style={{ marginBottom: '16px' }}>
              <DatePicker.RangePicker
                format="YYYY-MM-DD"
                value={dateRange && dateRange[0] && dateRange[1] ? dateRange : initialDateRange}
                defaultValue={initialDateRange}
                onChange={(dates) => {
                  onDateRangeChange && onDateRangeChange(dates);
                }}
                placeholder={['Start Date', 'End Date']}
              />
            </Row>
            <Row type="flex" justify="center" align="middle">
              <Empty description="No signup data available" style={{ marginTop: 24 }} />
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }

  // Transform data to match SingleAxisArea format (date -> xAxis, signups -> count for chart)
  const chartData = data.map((item) => ({
    xAxis: item.date,
    count: item.signups,
  }));

  return (
    <Row style={styles.container} type="flex">
      <Col xs={24}>
        <Card
          title={<CardTitleText text={'Sign-Up Chart by Date'} />}
          style={{ height: '35em' }}
          headStyle={{ borderWidth: '2px' }}
          bodyStyle={{ padding: '2%', paddingBottom: '3%' }}
          bordered
        >
          <Row type="flex" justify="center" style={{ marginBottom: '16px' }}>
            <DatePicker.RangePicker
              format="YYYY-MM-DD"
              value={dateRange && dateRange[0] && dateRange[1] ? dateRange : initialDateRange}
              defaultValue={initialDateRange}
              onChange={(dates) => {
                onDateRangeChange && onDateRangeChange(dates);
              }}
              placeholder={['Start Date', 'End Date']}
            />
          </Row>
          <SingleAxisArea
            tooltipName="Sign Ups"
            leftY="count"
            data={chartData}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default SignUpsV2Chart;
